(() => {
  const init = (root) => {
    const slides = Array.prototype.slice.call(root.querySelectorAll(".kimit-slide"));
    if (!slides.length) return;
    let activeIndex = 0;
    let sliderDuration = parseInt(root.getAttribute("data-duration") || "5", 10) * 1000;

    // すべての動画を取得
    const videos = slides.map((slide) => slide.querySelector("video")).filter((v) => v);

    if (slides.length === 1) {
      slides[0].classList.add("is-active");
      if (videos[0]) videos[0].play();
      return;
    }

    const slideToggle = () => {
      // 現在の動画を停止
      if (videos[activeIndex]) {
        videos[activeIndex].pause();
      }

      slides[activeIndex].classList.remove("is-active");
      activeIndex = (activeIndex + 1) % slides.length;
      slides[activeIndex].classList.add("is-active");

      // 次の動画を再生
      if (videos[activeIndex]) {
        videos[activeIndex].currentTime = 0;
        videos[activeIndex].play().catch((e) => console.log("Video play error:", e));
      }

      setTimeout(slideToggle, sliderDuration);
    };

    slides[0].classList.add("is-active");
    if (videos[0]) videos[0].play().catch((e) => console.log("Video play error:", e));
    setTimeout(slideToggle, sliderDuration);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      document.querySelectorAll(".kimit-slide-container").forEach(init);
    });
  } else {
    document.querySelectorAll(".kimit-slide-container").forEach(init);
  }
})();
